import AntdTable from 'antd/es/table';
import Table from './Table';

const AntdTableType: typeof AntdTable = Object.assign({}, AntdTable, Table);

export default AntdTableType;

export type { ColumnProps } from 'antd/es/table';
export type { ColumnGroupType, ColumnsType, ColumnType } from 'antd/es/table';
export type { TableProps, TablePaginationConfig } from 'antd/es/table';
export type { TableRowSelection } from 'antd/es/table/interface';
